import { Close } from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  MenuItem,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FormEvent, useCallback, useState } from "react";
import { useGetProductsQuery } from "src/api/services/productsApi";
import { useCreateCouponMutation } from "src/api/services/couponsApi";
import LoadingButton from "src/components/Buttons/LoadingButton/LoadingButton";
import { desktopSx } from "src/utils/styles/modalStyles";

type ModalTypes = {
  open: boolean;
  onClose: (o: boolean) => void;
};
const NewCouponModal = ({ open, onClose }: ModalTypes) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [couponName, setCouponName] = useState<string>("");
  // const [priceId, setPriceId] = useState<number | null>(null);
  const [productId, setProductId] = useState<number | null>(null);
  const [discount, setDiscount] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const { products } = useGetProductsQuery(undefined, {
    selectFromResult: ({ data }) => {
      return { products: data?.data ?? [] };
    },
  });
  // const { data: prices = [] } = useGetPricesByProductQuery(
  //   productSlug || skipToken
  // );
  const [createCoupon] = useCreateCouponMutation();

  // const clinicianName = useClinician(
  //   (clinian) => `${clinian.profile.first_name} ${clinian.profile.last_name}`
  // );

  const handleNewBanner = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      if (!couponName || !discount || !productId) {
        setError("Please fill out all fields");
        return;
      }

      const stripe_product_id = products.find(
        (product) => product.id === productId
      )?.stripe_product_id;

      if (stripe_product_id == null) {
        setError("Please make sure you are using correct product");
        return;
      }

      setLoading(true);

      try {
        await createCoupon({
          product_id: productId,
          name: couponName,
          amount: Number(discount),
          stripe_product_id,
        }).unwrap();

        onClose(false);
        setDiscount("");
        setCouponName("");
        setProductId(null);
      } catch (error) {
        console.error("Error creating new banner", error);
        setError("Oops, Something went wrong!!!");
      } finally {
        setLoading(false);
      }
    },
    [couponName, createCoupon, discount, onClose, productId, products]
  );

  return (
    <Modal open={open}>
      <Stack sx={desktopSx} gap={2}>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontWeight={700} variant="h5">
            New Coupon
          </Typography>
          <IconButton onClick={() => onClose(false)}>
            <Close fontSize="medium" />
          </IconButton>
        </Stack>
        <Stack
          gap={2}
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={handleNewBanner}
        >
          <FormControl>
            <TextField
              label="Coupon name"
              value={couponName}
              onChange={(e) => setCouponName(e.target.value)}
              required
            />
          </FormControl>

          <FormControl>
            <TextField
              type="number"
              label="Discount"
              value={discount}
              onChange={(e) => setDiscount(e.target.value)}
              required
            />
          </FormControl>

          <FormControl>
            <TextField
              select
              required
              label="Product"
              value={productId || ""}
              onChange={(e) => setProductId(Number(e.target.value))}
            >
              {products.map((product) => (
                <MenuItem value={product.id} key={product.id}>
                  {product.name}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
          {error ? (
            <Typography sx={{ color: "red" }} textAlign="center">
              {error.toString()}
            </Typography>
          ) : null}
          <LoadingButton loading={loading} type="submit">
            Create
          </LoadingButton>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default NewCouponModal;
